import Vue from 'vue'
import VueI18n from 'vue-i18n'
import znCN from "../assets/i18n/zh"
import enUS from "../assets/i18n/en"
Vue.use(VueI18n)

// 以下为语言包单独设置的场景，单独设置时语言包需单独引入
const messages = {
  'zh_CN': znCN,   // 中文语言包
  'en_US': enUS    // 英文语言包
}

// 最后 export default，这一步肯定要写的。
export default new VueI18n({
  locale : localStorage.getItem('language')||'zh_CN', // set locale 默认显示英文
  // locale: 'zh_CN', // set locale 默认显示英文
  messages: messages // set locale messages
})



// WEBPACK FOOTER //
// ./src/tools/i18n.js